import { useEffect } from "react";
import { motion, useSpring, useTransform } from "framer-motion";
import numeral from "numeral";

const RankingNumberCount = ({ value, notFixed = false }) => {
  const spring = useSpring(0, {
    mass: 0.8,
    stiffness: 75,
    damping: 15,
    restDelta: 0.01,
  });

  const display = useTransform(spring, (current) =>
    numeral(current).format(notFixed ? "0,0" : "0,0.0"),
  );

  useEffect(() => {
    spring.set(Number(value) || 0);
  }, [value, spring]);

  return <motion.span>{display}</motion.span>;
};

export default RankingNumberCount;
